class VariantPicker extends HTMLElement {
  connectedCallback() {
    this._handleOptionChange = this._handleOptionChange.bind(this);
    this.addEventListener("change", this._handleOptionChange);

    this.simpleSizeButtons = this.querySelectorAll(
      ".product-options--text-button"
    );
    this.simpleSizeButtons.forEach((button) => {
      button.addEventListener("click", this._handleButtonClick);
    });
  }

  disconnectedCallback() {
    this.removeEventListener("change", this._handleOptionChange);
    this.simpleSizeButtons.forEach((button) => {
      button.removeEventListener("click", this._handleButtonClick);
    });
  }

  _handleOptionChange(event) {
    event.stopPropagation();

    this.dispatchEvent(
      new CustomEvent("variant-picker:change", {
        detail: {
          variantID: event.target.dataset.variantId,
        },
        bubbles: true,
        composed: true,
      })
    );
  }

  _handleButtonClick(event) {
    const currentTarget = event.target;
    const inputNameToChange = currentTarget.dataset.name;
    const inputValueToChange = currentTarget.dataset.value;

    const productCardsCompleteSet = document.querySelector(
      ".product-cards-complete-set"
    );

    if (productCardsCompleteSet) {
      const inputToChange = productCardsCompleteSet.querySelector(
        `[name="${inputNameToChange}"][value="${inputValueToChange}"]`
      );

      if (inputToChange) {
        inputToChange.click();
      }
    }
  }
}

customElements.define("variant-picker", VariantPicker);
